"use client";
import { Skeleton } from "@radix-ui/themes";
import { useTranslations } from "next-intl";
import { DataInputParams } from "./inputType";
import { GetDataInputElement, getTooltip, getValueLabel, getValueList } from "./inputFunction";
import { Debug } from "@/util/debug";
import { Flex, Tooltip } from "antd";
import { useEffect, useState } from "react";
import { tooltipColor } from "../list/defaultType";
export default function Element(params: DataInputParams) {
  const t = useTranslations(params.transitionGroup ?? "contents");
  const spacingFront = typeof params.elementProp !== "string" ? !(params.elementProp?.iconFront ?? true) : false;
  const value = params.elementProp ? GetDataInputElement(params.elementProp, spacingFront, params.values, t, params) : "";
  const [tooltip, setTooltip] = useState(getTooltip(t, params));
  useEffect(() => {
    setTooltip(getTooltip(t, params));
  }, [t, params, params.tooltip]);
  if (value == null || value == undefined) {
    return <Skeleton loading={params.loading ?? false}>{(params.loading ?? false) ? "blank" : " "}</Skeleton>;
  } else {
    //Debug(params);
    const prev = params.prev ? GetDataInputElement(params.prev, false, params.values, t) : undefined;
    const unitPrev = params.unitPrev ? GetDataInputElement(params.unitPrev, false, params.values, t) : undefined;
    const unit = params.unit ? GetDataInputElement(params.unit, true, params.values, t) : undefined;
    const next = params.next ? GetDataInputElement(params.next, true, params.values, t) : undefined;
    return (
      <Tooltip color={tooltipColor} title={tooltip} placement={params.tooltipPlacement} {...params.tooltipProps}>
        <Flex>
          <Skeleton loading={params.loading ?? false}>
            {prev}
            {unitPrev}
            {value}
            {unit}
            {next}
          </Skeleton>
        </Flex>
      </Tooltip>
    );
  }
}
